// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"d567773a","633":"ff3a0de8","659":"bd918443","710":"b0236abc","861":"0fb4fe0a"}[chunkId] + ".chunk.css";
};